import { render, staticRenderFns } from "./TOProposalInsureds.vue?vue&type=template&id=20d8c3da"
import script from "./TOProposalInsureds.vue?vue&type=script&lang=js"
export * from "./TOProposalInsureds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports